
<div *ngIf="Products.length==0 && empty_products==null" class="row container-fluid mb-4" style="padding: 20px;"  >

<div class="col-md-3 col-sm-12 text-left"><app-product-block-shimmer></app-product-block-shimmer></div>
<div class="col-md-3 col-sm-12 text-left"><app-product-block-shimmer></app-product-block-shimmer></div>
<div class="col-md-3 col-sm-12 text-left">  <app-product-block-shimmer></app-product-block-shimmer></div>
<div class="col-md-3 col-sm-12 text-left"> <app-product-block-shimmer></app-product-block-shimmer></div>
</div>



<div class=""  >
    <div class="row  slider-header p-2">
        <div class="col-6">
            <div routerLink="categories/{{category_id}}" style="cursor: pointer;" *ngIf="title!='' && Products.length" class="title">{{title}}</div>
        </div>
        <div class="col-6 text-right">
            <div *ngIf="sliderType=='category'" style="font-size: 18px;"><a  href="#" class="btn btn-primary" routerLink="categories/{{category_id}}" i18n> View all</a></div>
        </div>
    </div>

    <div *ngIf="empty_products" class="text-center p-5">
        No products available.
    </div>

    <div class="p-5">
    <owl-carousel-o  *ngIf="Products.length > 0;" (drag)="test()" (dragend)="test2()"  [options]="customOptions" (translated)="loadNextProducts($event)">

        <ng-template *ngFor="let product of Products" carouselSlide>
            <app-product-block [item]="product"></app-product-block>
        </ng-template>

    </owl-carousel-o>
    </div>
</div>


